import { Component, OnInit } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { NgxSonnerToaster } from "ngx-sonner";
import { Appsettings } from "../../appsettings";
import { OpenAPI } from "./api";
import { ShellUifComponent } from "./common/ui-fragments/shell-uif/shell-uif.component";
import { Session } from "./common/util/Session";

@Component({
  selector: "app-root",
  imports: [RouterOutlet, NgxSonnerToaster, ShellUifComponent],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
})
export class AppComponent implements OnInit {
  title = Appsettings.getMainTitle();

  ngOnInit() {
    OpenAPI.BASE = Appsettings.getApiUrl();
    OpenAPI.TOKEN = Session.getAuthToken() ?? undefined;
  }
}
